import { create } from 'zustand';

export interface ProfileShareTarget {
  name: string;
  profileIdentifier: string;
  initials?: string;
  avatarUrl?: string;
  school?: string;
}

interface ProfileShareState {
  isOpen: boolean;
  target: ProfileShareTarget | null;
  openProfileShare: (target?: ProfileShareTarget) => void;
  closeProfileShare: () => void;
}

export const useProfileShareStore = create<ProfileShareState>((set) => ({
  isOpen: false,
  target: null,
  openProfileShare: (target) => set({ isOpen: true, target: target ?? null }),
  closeProfileShare: () => set({ isOpen: false, target: null }),
}));
